import axios from 'axios';
import { getApiBaseUrl, setupAxiosAuth } from '../utils/urlConfig';

const API_BASE_URL = `${getApiBaseUrl()}/admin/analytics`;

const setupRequest = () => {
  setupAxiosAuth(axios);
};

/**
 * Strip empty values and collapse arrays into the comma-separated form the
 * controller's `parseList` expects.
 */
const toParams = (filters = {}) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value)) {
      if (!value.length) return;
      params[key] = value.join(',');
      return;
    }
    params[key] = value;
  });
  return params;
};

export const fetchAnalyticsOverview = async (filters = {}) => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/overview`, { params: toParams(filters) });
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics overview:', error);
    throw error;
  }
};

export const fetchMentorUsage = async (filters = {}) => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/mentors`, { params: toParams(filters) });
    return response.data;
  } catch (error) {
    console.error('Error fetching mentor usage:', error);
    throw error;
  }
};

export const fetchMentorAnalytics = async (mentorId, filters = {}) => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/mentors/${mentorId}`, {
      params: toParams(filters),
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching analytics for mentor ${mentorId}:`, error);
    throw error;
  }
};

export const fetchAnalyticsFilterOptions = async () => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/filters`);
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics filter options:', error);
    throw error;
  }
};
